(function () {
    'use strict';

    var controllerId = 'shellController';
    var module = angular.module('inoApp.directives.layout');

    module.directive('layoutShell', [function () {
        var directive = {
            restrict: 'E',
            replace: true,
            controller: controllerId,
            controllerAs: 'shellVm',
            templateUrl: 'templates/core/layout/shell.html'
        };

        return directive;
    }]);
    
    module.controller(controllerId, ['$q', '$rootScope', '$scope', 'common', 'config', 'userService', shellController]);

    function shellController($q, $rootScope, $scope, common, config, userService) {
        var vm = this;
        var amountBusyPromisesToResolve = 0;
        var deferredBusy;

        vm.appRoot = config.clientAppSrcPath;
        vm.busyIndicatorConfig = {
            promise: null,
            templateUrl: 'templates/core/layout/loadingIndicator.html',
            textResourceKey: ''
        };
        vm.setIsBusy = setIsBusy;
        vm.timeoutSignInUrl = config.servicesUrl.identity.signInUrl;
        vm.userProfile = userService.currentUser.profile;

        activate();

        function activate() {
            common.handleBusyState([], controllerId);
        }

        $scope.toggleAuthorizationDialog = function (visible) {
            $scope.authorizationDialogVisible = visible;
            $('#authorization-dialog').modal({
                keyboard: false,
                show: visible,
                backdrop: false
            });
        };
        $scope.isAuthorizationDialogVisible = function () {
            return $scope.authorizationDialogVisible;
        }

        $scope.toggleAuthenticationDialog = function (visible) {
            $scope.authenticationDialogVisible = visible;
            $('#authentication-dialog').modal({
                keyboard: false,
                show: visible,
                backdrop: 'static'
            });
        };

        function setIsBusy(isBusy, textResourceKey) {
            if (isBusy) {
                // If we already had a promise and we have other calls to is busy do nothing.
                if (deferredBusy && typeof deferredBusy.resolve === 'function' && amountBusyPromisesToResolve > 0)
                    return;

                deferredBusy = $q.defer();
                vm.busyIndicatorConfig.textResourceKey = textResourceKey;
                vm.busyIndicatorConfig.promise = deferredBusy.promise;
            } else {
                if (deferredBusy && amountBusyPromisesToResolve === 0) {
                    vm.busyIndicatorConfig.textResourceKey = '';
                    deferredBusy.resolve();
                }
            }
        }

        $rootScope.$on(config.events.appWorkStarted, function (eventArgs, data) {
            var data = data || {};
            vm.setIsBusy(true, data.textResourceKey);
            amountBusyPromisesToResolve++;

            logAppWork('appWorkStarted', data.taskId);
        });

        $rootScope.$on(config.events.appWorkFinished, function (eventArgs, data) {
            if (amountBusyPromisesToResolve > 0)
                amountBusyPromisesToResolve--;

            vm.setIsBusy(false);

            logAppWork('appWorkFinished', data.taskId);
        });

        function logAppWork(event, taskId) {
            common.logger.log(event + ' from ' + taskId + '. Remaining promises: ' + amountBusyPromisesToResolve);
        }
    };
})();